/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import axios from "axios"

// initial state
const initialState = {
  stepper: {
    currentStep: 1,
    previousStep: 1,
    show: true
  },
  errorData: {},
  lastFourCC: "",
  invititation: {
    inviteId: "",
    senderUserName: "",
    inviteeEmail: "",
    clientInvitedTo: "",
    teamInvitedTo: "",
    companyName: ""
  },
  userInfo: {
    username: "",
    password: "",
    verifyPassword: "",
    email: "",
    lastName: "",
    firstName: "",
    companySize: "",
    industry: "",
    companyName: "",
    acknowledgeTerms: true, // set it to true to bypass validation
    accountOwner: true,
    nonce: ""
  },
  plan: {
    planType: "",
    teamType: "SINGLE",
    searchOptions: ["NAME"] // possible values: NAME | NPI | OFAC | SSNDMF
  }
}

const state = Object.assign({}, initialState)

const getters = {
  stepper: state => state.stepper,
  planType: state => state.plan.planType,
  teamType: state => state.plan.teamType,
  payment: state => state.plan.payment,
  searchOptions: state => state.plan.searchOptions,
  creationRequest: state => {
    return {
      plan: state.plan,
      userInfo: state.userInfo,
      userInviteId: state.invititation.inviteId
    }
  },
  userInfo: state => state.userInfo,
  lastFourCC: state => state.lastFourCC,
  errorData: state => state.errorData,
  userInvitationInfo: state => state.invititation
}

const actions = {
  loadInvitation(context, invitationId) {
    return axios
      .get(`/services/user/invite/${invitationId}`)
      .then(response => context.commit("updateInvitationInfo", response.data))
  }
}

const mutations = {
  updateCurrentStep(state, step) {
    state.stepper.previousStep = state.stepper.currentStep
    state.stepper.currentStep = step
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    })
  },
  updatePlanType(state, planType) {
    state.plan.planType = planType
    state.stepper.show = planType === "COMPANY"
  },
  updateTeamType(state, type) {
    state.plan.teamType = type
  },
  updateLastFourCC(state, lastFourCC) {
    state.lastFourCC = lastFourCC
  },
  updateSearchOptions(state, searchOptions) {
    state.plan.searchOptions = searchOptions
  },
  updateErrorData(state, errorData) {
    state.errorData = errorData
  },
  updateInvitationInfo(state, info) {
    state.invititation = info
    state.userInfo.email = info.inviteeEmail
    state.userInfo.companyName = info.companyName
    state.userInfo.accountOwner = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/registration.js